/**
 * /frontend/src/features/analytics/components/charts/ComparisonBarChart.js
 */

import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { CHART_CONFIG } from '../../constants/chartConfig';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Generic bar chart for comparisons.
 * @param {{data:any[],xKey:string,yKey:string,height?:number,color?:string,yFormatter?:(v:any)=>string}} props
 * @returns {JSX.Element}
 */
const ComparisonBarChart = ({ data, xKey, yKey, height, color, yFormatter }) => {
  const safeData = Array.isArray(data) ? data : [];
  if (!safeData.length) {
    return <div className="analytics-chart-empty-inline">No data available for the selected range.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={height || CHART_CONFIG.height}>
      <BarChart data={safeData} margin={CHART_CONFIG.margin}>
        <CartesianGrid stroke={CHART_CONFIG.gridStroke} strokeDasharray="4 6" />
        <XAxis dataKey={xKey} stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} />
        <YAxis stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} tickFormatter={yFormatter} />
        <Tooltip formatter={yFormatter} />
        <Bar dataKey={yKey} fill={color || CHART_COLORS.accent} radius={[10, 10, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ComparisonBarChart;
